import { render, staticRenderFns } from "./parentPrize.vue?vue&type=template&id=29dd9396&scoped=true"
import script from "./parentPrize.vue?vue&type=script&lang=js"
export * from "./parentPrize.vue?vue&type=script&lang=js"
import style0 from "./parentPrize.vue?vue&type=style&index=0&id=29dd9396&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dd9396",
  null
  
)

export default component.exports